// extracted by mini-css-extract-plugin
export default {"con-dialog-title":"JfWkHD5F"};